import { render } from "./OverSoldLeadReport.vue?vue&type=template&id=3dd8b9c9"
import script from "./OverSoldLeadReport.vue?vue&type=script&lang=js"
export * from "./OverSoldLeadReport.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__